import httpClient from '../http/http-client';
import { IReleaseNote } from './release-notes-model';

export default class ReleaseNotesService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IReleaseNote[] }> {
    return this.http.get(`release-note?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // Every released note in one call (the list endpoint skips pagination when page/perPage are
  // omitted), so the Release Notes page can search and filter them without a round trip.
  async getAllReleased(): Promise<IReleaseNote[]> {
    return this.http.get(`release-note?released=true`)
      .then(response => {
        return response.data?.rows ?? []
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(releaseNoteId: string): Promise<IReleaseNote> {
    return this.http.get(`release-note/${releaseNoteId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(releaseNote: FormData): Promise<IReleaseNote> {
    return this.http.post(`release-note`, releaseNote)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(releaseNoteId: string, releaseNote: FormData): Promise<IReleaseNote> {
    return this.http.patch(`release-note/${releaseNoteId}`, releaseNote)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async delete(releaseNoteId: string): Promise<IReleaseNote> {
    return this.http.delete(`release-note/${releaseNoteId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}